import React from 'react';
import { CommonDeleteModal } from 'components/common';
import { useDeleteModal } from './useDeleteModal';

interface IDeleteModal {
  openModal: boolean;
  dataToDelete: { id: string };
  onDeleteModalClose: () => void;
}

export const DeleteModal = (props: IDeleteModal) => {
  const { openModal, onDeleteModalClose, dataToDelete } = props;
  const { onRemoveConfirm, contextHolder, isLoading } = useDeleteModal(onDeleteModalClose);
  return (
    <>
      {contextHolder}
      <CommonDeleteModal
        onCancel={() => onDeleteModalClose()}
        isLoading={isLoading}
        open={openModal}
        onOk={() => onRemoveConfirm(dataToDelete)}
        onClose={() => onDeleteModalClose()}
        title={'Delete Online Shop'}
        message={'Are you sure you want to delete this Online Shop?'}
      />
    </>
  );
};
